const NAIVE_ISO = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;

export function parseDecisionTimestamp(timestamp) {
  if (!timestamp) return null;
  const value = String(timestamp).trim();
  if (!value) return null;
  // Only naive ISO is missing a zone. RFC 822 ("GMT", "+0000") already parses;
  // appending Z makes those strings invalid and the card shows "Recently".
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);
  const normalized = !hasZone && NAIVE_ISO.test(value)
    ? `${value.replace(' ', 'T')}Z`
    : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatTimestamp(timestamp, now = new Date()) {
  try {
    const date = parseDecisionTimestamp(timestamp);
    if (!date) return 'Recently';
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
  } catch {
    return 'Recently';
  }
}
